import { IntercomContext } from './shared';
import { useContext } from 'react';

export { IntercomContextProvider } from './intercom-context-provider';

export const useIntercomContext = () => {
  const context = useContext(IntercomContext);
  if (!context) {
    throw new Error('useIntercomContext requires an IntercomContextProvider');
  }

  return context;
};
